import React from 'react';
import sty from 'styled-components';

import { Link } from 'react-router-dom';

export default function Campaign(p){
    console.log(p);
    
    return <Container>
        <Header>
            <HeaderTitle>
                {
                    p.name
                }
            </HeaderTitle>
            <Delete onClick={()=>p.delete(p)}>
                Excluir
            </Delete>
        </Header>
        <Body>
            <LinkToUrl href={p.url} target="_blank">
                {
                   'Link para '+p.url
                }
            </LinkToUrl>
            {
                p.images.small.url ? <ImgSection>
                    <ImgHeader>
                        <ImgTitle>
                            Mobile
                        </ImgTitle>
                    </ImgHeader>
                    <Img src={p.images.small.url}/>
                </ImgSection> : null
            }
            {
                p.images.medium.url ? <ImgSection>
                    <ImgHeader>
                        <ImgTitle>
                            Tablet
                        </ImgTitle>
                    </ImgHeader>
                    <Img src={p.images.medium.url}/>
                </ImgSection> : null
            }
            {
                p.images.large.url ? <ImgSection>
                <ImgHeader>
                    <ImgTitle>
                        Desktop
                    </ImgTitle>
                </ImgHeader>
                <Img src={p.images.large.url}/>
            </ImgSection> : null 
            }
        </Body>
    </Container>
}

const Container = sty.div`
    box-shadow: 0px 2.5px 10px 0px rgba(170,170,170,.5);
    border-radius: .5rem;
    margin-bottom: 1rem;
    margin-right: 1rem;
    flex-direction: column;
    padding: 1rem;
`

const Header = sty.div`
    padding-bottom: 1rem;
    justify-content: space-between
`

const HeaderTitle = sty.p`
    font-size: 1.5rem;
    margin: 0;
`
const Body = sty.div`
    flex-direction: column;
`
const LinkToUrl = sty.a`
    margin-bottom: 1rem;
`
const ImgSection = sty.div`
    flex-direction: column;
    margin-bottom: .5rem;
`
const ImgHeader = sty.div`
`
const ImgTitle = sty.p`
    font-size: 1rem;
    margin: 0;
    margin-bottom: .5rem;
`
const Img = sty.img`
    width: 100%;
    max-width: 25rem
    border-radius: .5rem;
`
const Delete = sty.button`

`